<template>
    <div
        id="support"
        :class="{
            desktop: $mq != 'sm',
            player: store.privatePlayerVisible,
            extended:
                store.privatePlayerItem.type != 'stream' &&
                store.privatePlayerItem.type != 'playlist',
        }"
    >
        <p>
            Montez Press Radio is ad-free and dependent on donations and the
            support of its listeners.<br />
            Subscribers of Montez Press Radio get unlimited access to our
            evergrowing archive of shows.
        </p>
        <router-link
            :to="{ name: 'subscribe' }"
            :class="{ up: visible }"
            ref="supportLink"
            >Support Montez Press Radio</router-link
        >
    </div>
</template>

<script>
import { EventBus } from "../eventBus.js";
import { store } from "../store";

export default {
    name: "Support",
    data() {
        return {
            visible: true,
            store: store,
        };
    },
    // watch: {
    //     "store.valid"(newVal, oldVal) {
    //         if (
    //             newVal != oldVal &&
    //             (this.$route.name == "home" || this.$route.name == "archive")
    //         ) {
    //             if (newVal == true) {
    //                 this.visible = false;
    //             }
    //         }
    //     },
    //     "$route.name"(newVal, oldVal) {
    //         if (
    //             // (newVal == "home" || newVal == "archive") &&
    //             this.store.valid == false
    //         ) {
    //             this.visible = true;
    //         } else {
    //             this.visible = false;
    //         }
    //     }
    // },
    // mounted() {
    //     let myself = this;
    //     setTimeout(function() {
    //         if (
    //             myself.store.valid == false &&
    //             (myself.$route.name == "home" ||
    //                 myself.$route.name == "archive")
    //         ) {
    //             myself.visible = true;
    //         }
    //     }, 5000);
    // },
    // created() {
    //     let myself = this;
    //     if (myself.store.valid == false) {
    //         EventBus.$on("footer", state => {
    //             if (
    //                 myself.store.valid == false &&
    //                 (myself.$route.name == "home" ||
    //                     myself.$route.name == "archive")
    //             ) {
    //                 myself.visible = !state;
    //             }
    //         });
    //     }
    // }
};
</script>

<style scoped>
#support {
    /* position: fixed; */
    /* right: -21rem; */
    /* bottom: 4.2rem; */
    padding: 0.7rem 1rem 0.8rem;
    /* border-top: 1px solid black; */
    /* transition: right 1s; */
    background-color: #f9f57d;
    width: 100%;
    display: flex;
    box-sizing: border-box;
    align-items: flex-start;
    margin-top: -1px;
    flex-wrap: wrap;
    justify-content: center;
    gap: 1rem;
    text-align: center;
}
#support.player {
    /* padding-bottom: 6.1rem; */
    /* padding-bottom: 7.4rem; */
}
#support.player.extended {
    /* padding-bottom: 6.6rem; */
    /* padding-bottom: 7.9rem; */
}
#support.desktop {
    align-items: center;
    justify-content: space-between;
    flex-wrap: nowrap;
    text-align: initial;
}
a {
    padding: 6px 13px;
    border: 1px solid black;
    display: block;
    box-sizing: border-box;
    flex-shrink: 0;
}
a:hover {
    background-color: black;
    color: #f9f57d;
}
p {
    margin: 0;
}
.up {
    /* right: 12px; */
}
</style>
